import { render, staticRenderFns } from "./Legend.vue?vue&type=template&id=56634e08&scoped=true"
import script from "./Legend.vue?vue&type=script&lang=js"
export * from "./Legend.vue?vue&type=script&lang=js"
import style0 from "./Legend.vue?vue&type=style&index=0&id=56634e08&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56634e08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56634e08')) {
      api.createRecord('56634e08', component.options)
    } else {
      api.reload('56634e08', component.options)
    }
    module.hot.accept("./Legend.vue?vue&type=template&id=56634e08&scoped=true", function () {
      api.rerender('56634e08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/gestion/career/partials/TimeLine/Legend.vue"
export default component.exports